import { saveDanceStyle, getAllDanceStyle, updateDanceStyle, deleteDanceStyle } from '../../../services/StyleDanceService';
export default {
    async addNewTypeDance(context, typeDancePayload) {
        const newTypeDance = {
            name: typeDancePayload.name,
            description: typeDancePayload.description,
            prerequisites: typeDancePayload.prerequisites,
            teachers: typeDancePayload.teachers,
            category: typeDancePayload.category,
            days: typeDancePayload.days,
            school: context.rootGetters['school/getSchoolId'],
            useSchoolLocation: typeDancePayload.useSchoolLocation,
            lat: typeDancePayload.lat,
            lng: typeDancePayload.lng,
            formattedAddress: typeDancePayload.formattedAddress,
        }
        const response = await saveDanceStyle(newTypeDance, context.rootGetters['auth/getToken']);
        if (!response.success) {
            this.showTheError(response.message);
        }
        context.commit('saveNewTypeDance', {...newTypeDance, id: response.data.danceStyle._id});
        context.dispatch('loadTypesDance', {forceRefresh: true});
    },
    async loadTypesDance(context, payload = false) {

        if (!payload.forceRefresh && !context.getters.shouldUpdate) return;

        const response = await getAllDanceStyle(context.rootGetters['auth/getToken'], context.rootGetters['school/getSchoolId']);
        if (!response.success) {
            this.showTheError(response.error);        
        }
        context.commit('setTypesDance', response.data.danceStyles);
        context.commit('setFetchTimestamp');
    },

    setTypeDanceToEdit(context, typeDance) {
        context.commit('setTypeDanceToEdit', typeDance);
    },
    removeTypeDanceToEdit(context) {
        context.commit('setTypeDanceToEdit', null);
    },
    async updateTypeDance(context, typeDancePayload) {
        const { id, name, description, prerequisites, teachers, category, days, useSchoolLocation, lat, lng, formattedAddress, applyToExistingSchedule } = typeDancePayload;
        const data = { name, description, prerequisites, teachers, category, days, useSchoolLocation, lat, lng, formattedAddress, applyToExistingSchedule };
        const response = await updateDanceStyle(id, data, context.rootGetters['auth/getToken']);
        context.commit('updateTypeDanceInList', response.data.danceStyle);
        context.commit('setTypeDanceToEdit', null);
        if (applyToExistingSchedule) {
            context.dispatch('schedule/loadSchedule', { forceRefresh: true }, { root: true });
        }
        return response.data;
    },
    async deleteTypeDance(context, typeDanceId) {
        await deleteDanceStyle(typeDanceId, context.rootGetters['auth/getToken']);
        context.commit('removeTypeDance', typeDanceId);
    },
    showTheError(errorMessage) {
        const error = new Error(errorMessage);
        throw error;
    }
}